import { Observable } from 'rxjs';
import { environment } from '@/environments/environment';

import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TapfiliateService {
  trackEvent$(eventName: string, ...args: any[]): Observable<void> {
    return new Observable<void>((observer) => {
      if (!(window as any).tap) {
        observer.error(new Error('Tapfiliate not loaded'));
        return;
      }

      try {
        const tapAffiliateId = environment.tapfiliateId;
        if (eventName === 'create') {
          (window as any).tap(eventName, tapAffiliateId, ...args);
        } else {
          (window as any).tap(eventName, ...args);
        }

        observer.next();
        observer.complete();
      } catch (err) {
        observer.error(err);
      }
    });
  }
}
